import {
  ProductsDeptSubClazz,
  mergeProductDeptSubClazz,
} from './productsDeptSubClazz'
import { Products, mergeProducts } from './products'
import { FeedbackHighlights } from '../feedback/FeedbackHighlights'

export interface ProductsResponse {
  view: any[]
  sections: any[]
  productsDeptSubClazz: ProductsDeptSubClazz
  products: Products
  feedbackHighlights: FeedbackHighlights
  parentItemBpIds: any
  pmuRules: any
  readOnlyAttributesForCF: any[]
  eventUserViewId: any
}

export const mergeProductsResponses = (
  a: ProductsResponse,
  b: ProductsResponse,
): ProductsResponse => {
  const response: ProductsResponse = {
    ...a,
    products: mergeProducts(a.products, b.products),
    productsDeptSubClazz: mergeProductDeptSubClazz(
      a.productsDeptSubClazz,
      b.productsDeptSubClazz,
    ),
    feedbackHighlights: { ...a.feedbackHighlights, ...b.feedbackHighlights },
  }
  return response
}
